function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "heading", "headingLevel", "icon", "marginBottom", "marginLeft", "marginRight", "marginTop", "sentiment", "variation"],
  _excluded2 = ["children", "marginBottom", "marginLeft", "marginRight", "marginTop", "sentiment", "variation"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useMemo } from 'react';
import classnames from 'classnames';
import { BIRMINGHAM_MIDSHIRES, BLACK_HORSE, HALIFAX, LLOYDS } from "../../constants";
import Box from "../Box";
import { useBrand } from "../BrandProvider";
import Heading from "../Heading";
import { Information, Negative, Positive, Warning } from "../Icon";
import Text from "../Text";
import StyledNotification, { StyledNotificationBody, StyledNotificationContainer, StyledNotificationHeader, StyledNotificationIcon } from "./styled";
import BackgroundProvider from "../BackgroundProvider";
import { useTheme } from 'styled-components';
var Notification = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    heading = _ref.heading,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? 3 : _ref$headingLevel,
    customIcon = _ref.icon,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '05' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$sentiment = _ref.sentiment,
    sentimentProp = _ref$sentiment === void 0 ? 'information' : _ref$sentiment,
    _ref$variation = _ref.variation,
    variationReceived = _ref$variation === void 0 ? 'inpage' : _ref$variation,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var sentiment = sentimentProp;
  switch (sentimentProp) {
    /** @ts-ignore Invalid prop value allowed for deprecation purposes */
    case 'negative':
      sentiment = 'critical';
      console.warn("Value \"".concat(sentimentProp, "\" provided to `sentiment` prop is deprecated. Use \"").concat(sentiment, "\" instead."));
      break;
    /** @ts-ignore Invalid prop value allowed for deprecation purposes */
    case 'info':
      sentiment = 'information';
      console.warn("Value \"".concat(sentimentProp, "\" provided to `sentiment` prop is deprecated. Use \"").concat(sentiment, "\" instead."));
      break;
    /** @ts-ignore Invalid prop value allowed for deprecation purposes */
    case 'positive':
      sentiment = 'success';
      console.warn("Value \"".concat(sentimentProp, "\" provided to `sentiment` prop is deprecated. Use \"").concat(sentiment, "\" instead."));
      break;
    default:
      sentiment = sentimentProp;
  }
  var iconMap = {
    information: /*#__PURE__*/React.createElement(Information, {
      iconSize: "lg",
      size: "s3",
      color: sentiment
    }),
    critical: /*#__PURE__*/React.createElement(Negative, {
      iconSize: "lg",
      size: "s3",
      color: sentiment
    }),
    success: /*#__PURE__*/React.createElement(Positive, {
      iconSize: "lg",
      size: "s3",
      color: sentiment
    }),
    warning: [BIRMINGHAM_MIDSHIRES, HALIFAX].includes(brand) ? /*#__PURE__*/React.createElement(Warning, {
      iconSize: "lg",
      size: "s3",
      color: sentiment
    }) : /*#__PURE__*/React.createElement(Negative, {
      iconSize: "lg",
      size: "s3",
      color: sentiment
    })
  };
  var variation = [BIRMINGHAM_MIDSHIRES, BLACK_HORSE, HALIFAX].includes(brand) ? 'standalone' : variationReceived;
  var icon = useMemo(function () {
    if (!customIcon) return iconMap[sentiment || 'information'];
    return /*#__PURE__*/React.cloneElement(customIcon, _objectSpread({
      color: sentiment,
      iconSize: 'lg',
      size: 's3'
    }, customIcon.props));
  }, [customIcon, sentiment]);
  var className = classnames("csl-notification--".concat(sentiment), "csl-notification--".concat(variation), {
    'csl-notification--no-title': !heading,
    'csl-notification--no-children': !children
  });
  var bodyClassName = classnames('csl-notification__body', {
    'csl-notification__body--no-title': !heading
  });
  return /*#__PURE__*/React.createElement(NotificationContainer, _extends({
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    ref: ref,
    sentiment: sentiment,
    variation: variation
  }, rest), /*#__PURE__*/React.createElement(StyledNotification, {
    $noChildren: !children,
    $noTitle: !heading,
    $sentiment: sentiment,
    $variation: variation,
    className: className
  }, /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme["notification_color_".concat(variation, "_background_").concat(sentiment)]
    }
  }, /*#__PURE__*/React.createElement(NotificationHeader, {
    heading: heading,
    headingLevel: headingLevel,
    icon: icon,
    sentiment: sentiment,
    variation: variation
  }, !heading && /*#__PURE__*/React.createElement(StyledNotificationBody, {
    $noTitle: true,
    className: bodyClassName
  }, /*#__PURE__*/React.createElement(Text, null, children))), heading && children && /*#__PURE__*/React.createElement(StyledNotificationBody, {
    className: bodyClassName
  }, /*#__PURE__*/React.createElement(Text, null, children)))));
});
var NotificationHeader = function NotificationHeader(_ref3) {
  var children = _ref3.children,
    headingProp = _ref3.heading,
    headingLevel = _ref3.headingLevel,
    icon = _ref3.icon;
  var headingComponent = function headingComponent() {
    if (typeof headingProp === 'string') {
      var elementProps = {
        children: headingProp,
        marginBottom: 'none'
      };
      if (headingLevel) {
        if (headingLevel > 6) {
          elementProps['aria-level'] = headingLevel;
        } else {
          switch (headingLevel) {
            case 1:
              elementProps.as = 'h1';
              break;
            case 2:
              elementProps.as = 'h2';
              break;
            case 3:
              elementProps.as = 'h3';
              break;
            case 4:
              elementProps.as = 'h4';
              break;
            case 5:
              elementProps.as = 'h5';
              break;
            case 6:
              elementProps.as = 'h6';
              break;
            default:
            // do nothing
          }
        }
      }
      return /*#__PURE__*/React.createElement(Heading, elementProps);
    }
    return headingProp;
  };
  return /*#__PURE__*/React.createElement(StyledNotificationHeader, {
    className: "csl-notification__header"
  }, /*#__PURE__*/React.createElement(StyledNotificationIcon, {
    className: "csl-notification__icon"
  }, icon), headingComponent(), children);
};
var NotificationContainer = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    marginBottom = _ref4.marginBottom,
    marginLeft = _ref4.marginLeft,
    marginRight = _ref4.marginRight,
    marginTop = _ref4.marginTop,
    sentiment = _ref4.sentiment,
    variation = _ref4.variation,
    rest = _objectWithoutProperties(_ref4, _excluded2);
  if (variation === 'standalone') {
    return /*#__PURE__*/React.createElement(StyledNotificationContainer, _extends({
      $marginBottom: marginBottom,
      $marginLeft: marginLeft,
      $marginRight: marginRight,
      $marginTop: marginTop,
      $sentiment: sentiment,
      ref: ref
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    ref: ref
  }, rest, {
    bgColor: sentiment
  }), children);
});
Notification.displayName = 'Notification';
NotificationHeader.displayName = 'NotificationHeader';
export default Notification;